import { useContext, useMemo } from 'react';

import { XYChartDataContext } from '../context/XYChartData.context.js';
import {
  DOT_VARIANT,
  type DotSeriesToMetadata,
  type DotSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export interface DotDataInternal {
  filteredSeriesWithDatapoints: DotSeriesWithDatapoints[];
  seriesToMetadata: DotSeriesToMetadata;
}

export const useDotData = () => {
  const context = useContext(XYChartDataContext);

  if (context === undefined) {
    throw new Error('useDotData must be used within a XYChartDataContext');
  }

  const filteredContext = useMemo(() => {
    return {
      seriesToMetadata: context.seriesToMetadata,
      filteredSeriesWithDatapoints: context.filteredSeriesWithDatapoints.filter(
        (series) => series.type === DOT_VARIANT,
      ),
    };
  }, [context]);

  return filteredContext as Required<DotDataInternal>;
};
